// 前端脱敏工具：对手机号 / 邮箱这类“用户名”统一做脱敏显示。
// 与社区（bbs-go/site）NavTopBar.vue 的 maskLoginAccount 保持同一规则，
// 确保“网站”与“社区”右上角的用户名展示口径一致。

// 手机号脱敏：138****8000（保留前三后四）
export function maskPhone (value) {
  const account = String(value === null || value === undefined ? '' : value).trim()
  if (/^1[3-9]\d{9}$/.test(account)) {
    return `${account.slice(0, 3)}****${account.slice(-4)}`
  }
  return account
}

// 邮箱脱敏：a***b@example.com（保留首字符、末位及域名）
export function maskEmail (value) {
  const account = String(value === null || value === undefined ? '' : value).trim()
  const atIndex = account.indexOf('@')
  if (atIndex > 0 && atIndex < account.length - 1) {
    const localPart = account.slice(0, atIndex)
    const visibleTail = localPart.length > 2 ? localPart.slice(-1) : ''
    return `${localPart.slice(0, 1)}***${visibleTail}${account.slice(atIndex)}`
  }
  return account
}

// 统一登录账号脱敏：手机号 / 邮箱按规则脱敏，普通用户名（含微信昵称）原样返回。
export function maskLoginAccount (value) {
  const account = String(value === null || value === undefined ? '' : value).trim()
  if (!account) return account
  if (/^1[3-9]\d{9}$/.test(account)) {
    return maskPhone(account)
  }
  if (account.indexOf('@') > 0) {
    return maskEmail(account)
  }
  return account
}